<script setup>
import {Head, Link} from '@inertiajs/inertia-vue3'
import HeroIcon from '@/Shared/HeroIcon.vue'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import SearchFilter from '@/Shared/SearchFilter'
import {defineProps, reactive, ref, watch} from 'vue'
import {Inertia} from '@inertiajs/inertia'
import Pagination from '@/Shared/Pagination'
import LoadingButton from "@/Shared/LoadingButton.vue";

const props = defineProps({
  filters: Object,
  reports: Object,
  auth: Object,
  is_admin: Boolean,
})

const form = ref({
  search: props.filters ? props.filters.search : '',
})
const loading = ref(false)

watch(form.value, (newForm) => {
  if (form.value.search.length > 0) {
    loading.value = true
    Inertia.reload({
      only: ['reports'],
      data: pickBy(form.value),
      preserveState: true,
      onSuccess: () => {
        loading.value = false
      },
      progress: false,
    })
  } else if (form.value.search.length == 0) {
    Inertia.get('reports', {}, {
      onSuccess: () => {
        document.getElementById('search').focus()
      },
    })
  }
}, {})

const reset = () => {
  Inertia.get('reports')
}


const destroy = function (id) {
  if (confirm('Bist du dir sicher?')) {
    Inertia.delete(/reports/ + id)
  }
}
</script>

<template>
  <Layout :auth="props.auth">
    <div>
      <Head title="Feedback"/>
      <div class="flex justify-between ">
        <h1 class="mb-8 text-3xl w-full font-bold flex items-end text-orfBlue-100 border-b-2 pb-4">
          <HeroIcon name="chat-bubble-left-ellipsis" class="mr-2 h-10 w-10 fill-orfBlue-100"/>
          Alle Feedbacks ({{ props.reports.total }})
        </h1>
      </div>
      <div class="flex items-center justify-between mb-6">
        <search-filter v-model="form.search" class="w-full" @reset="reset" placeholder="Suche: Typ, E-Mail"/>
      </div>
      <div v-if="loading" class="btn-spinner border-orfBlue-100 absolute top-1/4 -left-1/4"/>
      <div class="bg-white rounded-md shadow">
        <div class="w-full whitespace-nowrap flex flex-col">
          <div class="hidden sm:flex text-left font-bold justify-between border-b items-center">
            <div class="pb-4 pt-6 px-6 w-1/6">Typ</div>
            <div class="pb-4 pt-6 px-6 w-1/5">E-Mail</div>
            <div class="pb-4 pt-6 px-6 flex-grow">Text</div>
            <div class="pb-4 pt-6 px-6 w-1/3 lg:w-1/6 text-right">Optionen</div>
          </div>
          <div v-for="report in reports.data" :key="report.id"
               class="hover:bg-gray-100 focus-within:bg-gray-100 py-3 flex gap-2 sm:gap-0 flex-col sm:flex-row items-start sm:items-center sm:justify-between border-t"
          >
            <div
              class="flex items-center px-6 justify-between items-center w-full sm:items-start sm:justify-start sm:w-1/6"
            >
              <div class="font-bold flex items-center capitalize">
                <HeroIcon name="user2" class="mr-1 w-6 sm:hidden fill-orfBlue-100"/>
                {{ report.type }}
              </div>
              <loading-button text="Löschen" icon-name="trash" icon-mini inverted small func="delete" class="flex sm:hidden" @click="destroy(report.id)"/>
            </div>
            <div class="w-1/5 px-6 flex items-center">
              <HeroIcon name="mail" class="mr-1 ml-1 w-4 sm:hidden fill-orfBlue-100"/>
              {{ report.email }}
            </div>
            <div class="flex-grow px-6 flex items-center w-96 whitespace-pre-wrap">
              {{ report.description }}
            </div>
            <div class="hidden sm:flex justify-end items-center w-1/3 lg:w-1/6 px-6">
              <loading-button text="Löschen" icon-name="trash" icon-mini inverted small func="delete" @click="destroy(report.id)"/>
            </div>
          </div>
        </div>
      </div>
      <div class="flex justify-center">
        <Pagination class="mt-6" :links="reports.links"/>
      </div>
    </div>
  </Layout>
</template>

